// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__rz+KG","legend":"NewCustomer_legend__nzU4b","indicator":"NewCustomer_indicator__oZuD5","color":"NewCustomer_color__r86ab"};